import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue')
  }, {
    path: '/index',
    name: 'Index',
    component: () => import('../views/index.vue')
  }
]

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由拦截
router.beforeEach(async(to, from, next) => {
  next();
})
export default router
